// Profil d'inscription EN ATTENTE de persistance (web : localStorage).
//
// Les attributs saisis à l'inscription (prénom/nom/âge/pays) doivent être
// enregistrés en base via POST /me/profile. Comme cet appel peut échouer
// (réseau, cold start) ou ne pas avoir lieu (compte déjà existant -> chemin
// signin), on stocke les attributs ICI de façon DURABLE et on les rejoue
// (réconciliation) à chaque session authentifiée jusqu'à confirmation.
import type { SignupAttributes } from './nativeAuth.types';

const KEY = 'ccjaw.pendingProfile';

export async function setPendingProfile(p: SignupAttributes): Promise<void> {
  try { window.localStorage.setItem(KEY, JSON.stringify(p)); } catch { /* stockage indispo */ }
}

export async function getPendingProfile(): Promise<SignupAttributes | null> {
  try {
    const v = window.localStorage.getItem(KEY);
    return v ? (JSON.parse(v) as SignupAttributes) : null;
  } catch { return null; }
}

export async function clearPendingProfile(): Promise<void> {
  try { window.localStorage.removeItem(KEY); } catch { /* ignore */ }
}
